import { render } from "./DetailForm.vue?vue&type=template&id=4c334eba&scoped=true&ts=true"
import script from "./DetailForm.vue?vue&type=script&lang=ts"
export * from "./DetailForm.vue?vue&type=script&lang=ts"

import "./DetailForm.vue?vue&type=style&index=0&id=4c334eba&lang=scss&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/git_node_build_images_push_anjinq_test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c334eba"]])

export default __exports__